import { Pipe, PipeTransform } from '@angular/core';
import { RfqQuote } from '@approot/models';

@Pipe({
  name: 'indicativePremium'
})
export class IndicativePremiumPipe implements PipeTransform {
  transform(
    value: string,
    quote: RfqQuote,
    side: 'bid' | 'offer',
    forwardPointsMultiplier: number,
    baseCurrency: string,
    termCurrency: string
  ): string {
    switch (value) {
      case 'Pips': {
        const value =
          side === 'bid'
            ? quote.indicativePremium.premiumBidPipsTerm
            : quote.indicativePremium.premiumOfferPipsTerm;
        if (value == null) {
          return null;
        }
        return `${(Math.abs(value) * forwardPointsMultiplier).toFixed(1)} pips`;
      }
      case 'Percent Base': {
        const value =
          side === 'bid'
            ? quote.indicativePremium.premiumBidPercentBase
            : quote.indicativePremium.premiumOfferPercentBase;
        if (value == null) {
          return null;
        }
        return `${Math.abs(value).toFixed(3)}% ${baseCurrency}`;
      }
      case 'Percent Term': {
        const value =
          side === 'bid'
            ? quote.indicativePremium.premiumBidPercentTerm
            : quote.indicativePremium.premiumOfferPercentTerm;
        if (value == null) {
          return null;
        }
        return `${Math.abs(value).toFixed(3)}% ${termCurrency}`;
      }
      default:
        return null;
    }
  }
}
